import { createApp } from 'vue';
import ToastContainer from '@/components/ToastContainer.vue';

const POSITIONS = {
  TOP_RIGHT: 'top-right',
  TOP_LEFT: 'top-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_LEFT: 'bottom-left',
};

const TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
};

const DEFAULT_TIMEOUT = 5000;
const DEFAULT_POSITION = POSITIONS.TOP_RIGHT;

let containerInstance = null;
let toastSequence = 0;

const createToastId = () => `toast-${Date.now()}-${++toastSequence}`;

export default {
  install(app) {
    if (!containerInstance) {
      const containerDiv = document.createElement('div');
      containerDiv.id = 'toast-container';
      document.body.appendChild(containerDiv);

      const toastApp = createApp(ToastContainer);
      containerInstance = toastApp.mount('#toast-container');
    }

    app.config.globalProperties.$toast = {
      show(options) {
        if (typeof options === 'string') {
          options = { message: options };
        }
        if (!options?.message) {
          console.error('Toast requires a message');
          return null;
        }
        const config = {
          id: createToastId(),
          message: options.message,
          type: options.type || TYPES.INFO,
          position: options.position || DEFAULT_POSITION,
          timeout: options.timeout ?? DEFAULT_TIMEOUT,
          timestamp: Date.now(),
        };
        containerInstance?.addToast?.(config);
        if (typeof options.opaque === 'boolean') {
          containerInstance?.setOpaque?.(options.opaque);
        }
        return config.id;
      },
      success(message, options = {}) {
        return this.show({ message, type: TYPES.SUCCESS, ...options });
      },
      error(message, options = {}) {
        return this.show({ message, type: TYPES.ERROR, ...options });
      },
      info(message, options = {}) {
        return this.show({ message, type: TYPES.INFO, ...options });
      },
      dismiss(id) {
        containerInstance?.removeToast?.(id);
      },
      dismissAll() {
        containerInstance?.clearAll?.();
      },
      setOpaque(isOpaque) {
        containerInstance?.setOpaque?.(!!isOpaque);
      },
      POSITIONS,
      TYPES,
    };
  },
};
